/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripLocationPaginateResponse } from '../../models/camp-trip-location-paginate-response';

export interface GetCampTripLocationIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'label' | 'type' | 'priceDeparture' | 'priceReturn';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'label' | 'type' | 'priceDeparture' | 'priceReturn';

/**
 * Filter CampTripLocation id
 */
  id?: number;

/**
 * Filter CampTrip id
 */
  trip?: number;

/**
 * Filter camp id
 */
  camp?: number;

/**
 * Filter CampProgram id
 */
  program?: number;
}

export function getCampTripLocationIndex(http: HttpClient, rootUrl: string, params?: GetCampTripLocationIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripLocationPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getCampTripLocationIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('trip', params.trip, {});
    rb.query('camp', params.camp, {});
    rb.query('program', params.program, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripLocationPaginateResponse>;
    })
  );
}

getCampTripLocationIndex.PATH = '/v1/camp-trip-location';
